import { render, staticRenderFns } from "./Segurasp.vue?vue&type=template&id=35c46be3&scoped=true"
import script from "./Segurasp.vue?vue&type=script&lang=js"
export * from "./Segurasp.vue?vue&type=script&lang=js"
import style0 from "./Segurasp.vue?vue&type=style&index=0&id=35c46be3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c46be3",
  null
  
)

export default component.exports